import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login'
import View from './views/View'
import ViewerPDF from './views/ViewerPDF'
import ViewerVideo from "./views/ViewerVideo";
import Share from "./views/Share";
import Mail from "./views/Mail";
import ViewerAbstract from "./views/ViewerAbstract";
import Impress from "./views/Impress";
import PrivacyPolicy from "./views/PrivacyPolicy";
import store from './store/store';

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      component: Login
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/impress',
      component: Impress
    },
    {
      path: '/privacypolicy',
      component: PrivacyPolicy
    },
    {
      path: '/view',
      component: View
    },
    {
      path: '/view/:poster',
      component: View
    },
    {
      path: '/viewer/:id',
      name: 'poster',
      component: ViewerPDF
    },
    {
      path: '/viewer/additional_paper/:id',
      name: 'additional_paper',
      component: ViewerPDF
    },
    {
      path: '/viewer/video/:id',
      component: ViewerVideo
    },
    {
      path: '/viewer/abstract/:id',
      component: ViewerAbstract
    },
    {
      path: '/share/:id',
      component: Share
    },
    {
      path: '/mail/:id',
      component: Mail
    },
    {
      path: '*',
      redirect: '/home'
    }
  ],
})

export default router

//Activate for login
router.beforeEach((to, from, next) => {
  if (to.path != '/login') {
    if (store.state.login.enabled === true && store.state.login.authenticated !== true) {
      next('/login');
    } else {
      next();
    }
  } else {
    next();
  }
});
